'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loginThroughPopup;

var _AnalyticsActions = require('../actions/AnalyticsActions');

var _popup = require('./popup');

var _links = require('./links');

var _links2 = _interopRequireDefault(_links);

var _locationOrigin = require('./locationOrigin');

var _locationOrigin2 = _interopRequireDefault(_locationOrigin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGIN_WINDOW_NAME = 'HubSpotLoginWindow';
var POPUP_LOGIN_COMPLETED = 'POPUP_LOGIN_COMPLETED';

function loginThroughPopup(handleLogin, email) {
  (0, _AnalyticsActions.trackInteraction)('login-through-popup-started');

  var onLogin = typeof handleLogin === 'function' ? handleLogin : function () {
    return location.reload();
  };

  var handler = function handler(event) {
    if (event.data === POPUP_LOGIN_COMPLETED) {
      (0, _AnalyticsActions.trackInteraction)('login-through-popup-completed');
      window.removeEventListener('message', handler);
      onLogin();
    }
  };

  window.addEventListener('message', handler);

  (0, _popup.openPopup)(_links2.default.login(_locationOrigin2.default + '/popup-login-completed', email), LOGIN_WINDOW_NAME);
}
module.exports = exports['default'];